/**
 * "Back" on the pre-creation onboarding screens, so a person can change their
 * mind about the name or where the code lives. It goes to the previous screen
 * and keeps what they typed (the draft), it never asks them to start over.
 *
 * It exists only while nothing has been created. Once Continue on the
 * code-host screen (SV Cloud) or the GitHub connect has made the project,
 * going back would not undo it, so the build screen has no Back.
 */
import { useNavigate } from 'react-router';

import { t } from '../../lib/i18n/t';

export function BackLink({ to }: { to: string }) {
  const navigate = useNavigate();
  return (
    <button type="button" className="onb__back" onClick={() => navigate(to)}>
      <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false">
        <path d="M10 3 5 8l5 5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {t('Back')}
    </button>
  );
}
